export default __webpack_public_path__ + "static/media/service2.d3607b9b.jpeg";